<template>
  <div class="searchpage">
    <div class="downup" >
      <el-dropdown  @command="handleCommand" placement='bottom'>
        <span class="el-dropdown-link">
          批量操作<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">
            <i class="iconfont icon-xiazai1"></i>
            批量下载</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="searchtips"><span>搜索范围：</span>{{paramPath}}</div>
    <div class="content">
        <div class="tableheader">
          <div class="checkdown"><el-checkbox @change="checkalldownFn()" v-model="isallcheck"> #</el-checkbox></div>
          <div class="ttitle">标题</div>
          <div class="classification">分类</div>
          <div class="label">标签</div>
          <div class="operation">操作</div>
        </div>
        <ul class="themelist" v-if="showrecordsData.length>0">
          <li v-for="(item,index) in showrecordsData" :key="index">
            <div class="checkdown"><el-checkbox v-model="checkdownArr[(pageindex-1)*pagesize+index].ischeck"> {{(pageindex-1)*pagesize+index+1}}</el-checkbox></div>
            <div class="ttitle" @click="previewKmDoc(item)"  v-html="item.title"></div>
            <div class="classification">{{item.category_dictText?item.category_dictText:'--'}}</div>
            <div class="label" v-if="item.businessType_dictTextArr.length>0">
              <span v-for="(item1,index1) in item.businessType_dictTextArr" :key="index1">{{item1}}</span>
            </div>
            <div v-else class="label">--</div>
            <div class="operation">
              <i class="iconfont icon-xiazai4" @click="downloadKmDoc(item)"></i>
              <!-- <span></span>
              <i v-if="recordsShouChangData[(pageindex-1)*pagesize+index].isShouchang" class="iconfont icon-shoucang" @click="shouChangFn((pageindex-1)*pagesize+index)"></i>
              <i v-else class="iconfont icon-shoucang3" @click="shouChangFn((pageindex-1)*pagesize+index)"></i> -->
            </div>
          </li>
        </ul>
        <div class="paginationbox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordsData.length">
          </el-pagination>
        </div>
      </div>
      <p-d-f-modal iframe-i-d="pdfIDde" :p-d-furl="PDFurl" :showmodel="showmodel" :title="pdftitle" @closepdfmodel='closePdfModel'/>
      <el-dialog
      title="确认下载"
      :visible.sync="downDialogVisible"
      width="60%"
      center
      class="downdialogcls">
      <span>是否下载选中数据?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="downallloadKmDoc()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import {Checkbox} from 'element-ui';
Vue.use(Checkbox);
import PDFModal  from '@/components/common/PDFModal/index.vue'
import api from "@/api/home.js"
import commonUrl from '@/assets/js/baseurl'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:{
    PDFModal,
  },
  data() {
    return {
      currentPage4: 1,
      checkedall:false,
      searchInput:'',
      recordsData:[],
      showrecordsData:[],
      paramPath:'',
      pagesize:10,
      pageindex:1,
      recordsShouChangData:[],
      url: {
          previewKmDoc: commonUrl.baseUrl+'/ky/KM/kmDoc/new/previewKmDoc',
          downloadKmDoc: commonUrl.baseUrl+'/ky/KM/kmDoc/new/downloadKmDoc',
        },
        PDFurl:'',
        pdftitle:'',
        showmodel:false,
      checkdownArr:[],
      isallcheck:false,
      downDialogVisible:false,
      downlistArr:[],
    };
  },
  computed: {
			...mapGetters(["getSearchData"]),
    },
    watch:{
    getSearchData(result,oldData){
      if(result.paramPath[0]=='分类:'){
        this.paramPath =result.paramPath[0]+'知识专题';
      }else{
        this.paramPath =result.paramPath[0];
      }
        this.recordsShouChangData=[];
        this.checkdownArr=[]
      let newArr= result.kmSearchResultVOPage.records.map((item)=>{
        this.recordsShouChangData.push({
          isShouchang:false
        })
        this.checkdownArr.push({
          ischeck:false,
          id:item.id
        })
        item.businessType_dictTextArr=[];
        if(item.businessType_dictText){
          item.businessType_dictTextArr=item.businessType_dictText.split(',');
        }
        item.ischeck=false;
        return item
      })
        this.recordsData =newArr;
        this.showrecordsData=this.recordsData.slice(0,10);
    }
  },
  methods: {
    // 显示预览窗口，初始化
      previewKmDoc(record) {
        console.log(record,123)
        this.PDFurl =  this.url.previewKmDoc + "?docId=" + record.id;
        this.pdftitle ='预览 - ' + record.title.replace(/<.*?>/ig,"");
        this.showmodel=true;
      },
      closePdfModel(){
        this.showmodel=false;

      },
      //下载文件
      downloadKmDoc(record) {
        this.$message.warning('文件开始下载');
        api.downloadFileName(this.url.downloadKmDoc, {docId: record.id},this.$message)
      },
      downallloadKmDoc(){
        this.downDialogVisible=false;
        for(let i in this.downlistArr){
          this.downloadKmDoc({id:this.downlistArr[i]})
        }
      },
    shouChangFn(idx){
        this.recordsShouChangData[idx].isShouchang = !this.recordsShouChangData[idx].isShouchang;
      },
    handleSizeChange(val) {
        this.pagesize=val;
        this.showrecordsData=this.recordsData.slice((this.pageindex-1)*this.pagesize,(this.pageindex-1)*this.pagesize+this.pagesize);
    },
    handleCurrentChange(val) {
        this.pageindex=val;
        this.showrecordsData=this.recordsData.slice((this.pageindex-1)*this.pagesize,(this.pageindex-1)*this.pagesize+this.pagesize);
    },
    handleCommand(command) {
      let downidArr=[];
      let downarr=this.checkdownArr.slice((this.pageindex-1)*this.pagesize,(this.pageindex-1)*this.pagesize+this.pagesize);
      for(let i in downarr){
        if(downarr[i].ischeck){
          downidArr.push(downarr[i].id)
        }
      }
      console.log(downidArr)
      if(downidArr.length>0){
        this.downDialogVisible=true;
        this.downlistArr=downidArr;
      }else{
        this.$message.warning('未选择文件');
      }
    },
    checkalldownFn(){
      // this.showrecordsData.map((item)=>{
      //     item.ischeck=true;
      // })
      if(this.isallcheck){

        this.checkdownArr.map((item)=>{
          item.ischeck=true;
        })
      }else{
        this.checkdownArr.map((item)=>{
            item.ischeck=false;
        })
      }
      // let idx
      // for(let i =0;i<this.showrecordsData.length;i++){
      //   idx=this.checkdownArr.indexOf(this.showrecordsData[i].id);
      //   if(idx<0){
      //     this.checkdownArr.push(this.showrecordsData[i].id)
      //   }
      // }
    }
  },
  created(){
    
  },
  mounted(){
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.searchpage{
  width: 1200px;
  margin: 0 auto;
  border: 1px solid #E6E6E6;
  margin-top: 16px;
  margin-bottom: 64px;
  // padding: 16px 0 0 16px;
  padding-top: 16px;
  .downup{
    width: 105px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #B3B3B3;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
font-family: Source Han Sans CN;
font-weight: 400;
color: #333333;
margin-bottom: 8px;
margin-left: 16px;
  }
  .searchtips{
    width: 1168px;
    height: 40px;
    background: rgba(55,110,244,0.08);
    border: 1px solid #376EF4;
    border-radius: 4px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    padding-left: 16px;
    margin: 0 auto;
    span{
      font-weight: 600;
    }
  }
  .content{
      width: 1168px;
      margin: 0 auto;
      padding-bottom: 58px;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px 0px rgba(137,154,176,0.2);
      position: relative;
      margin-top: 16px;
      .tableheader{
        width: 100%;
        height: 40px;
        background: #F9F9F9;
        overflow: hidden;
        &>div{
          float: left;
          line-height: 40px;
          font-size: 14px;
font-family: Source Han Sans CN;
font-weight: 400;
color: #333333;
        }
        
      }
      .checkdown{
          width: 156px;
          padding-left: 24px;
            box-sizing: border-box;
            height: 40px;
      }
          .ttitle{
            width: 490px;
            height: 40px;
            // padding-left: 16px;
            cursor: pointer;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            padding-right: 20px;
          }
          .classification{
            width: 118px;
            height: 40px;
          }
          .label{
            width: 324px;
            height: 40px;
            overflow: hidden;
          }
          .operation{
            height: 40px;
          }
      .themelist{
          width: 100%;
          &>li{
            height: 40px;
            border-bottom: 1px solid #f5f5f5;
            &>div{
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 40px;
              float: left;
            }
            .label{
              span{
                display: inline-block;
                // width: 43px;
                padding: 0 8px;
                height: 20px;
                background-color: #FFF5DC;
                border-radius: 4px;
                text-align: center;
                line-height: 20px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #FFBF27;
                margin-right: 4px;
              }
            }
            .operation{
              .iconfont{
                color: #376EF4;
                font-size: 14px;
                cursor: pointer;
                margin-left: 8px;
              }
              span{
                display: inline-block;
                width: 1px;
                height: 8px;
                background: #5E6463;
                margin: 0 12px;
              }
            }
          }
          &>li:hover{
            background: #F6F9FF;
          }
        }
      .paginationbox{
        font-size: 13px;

        font-weight: 400;
        color: #333333;
        position: absolute;
        bottom: 12px;
        right: 16px;
      }
    }
}
.el-dropdown-menu{
  padding: 0;
}
.downdialogcls{
  height: 200px;
  margin-top: 20%;
  .el-dialog--center .el-dialog__body{
    height: 70px !important;
    .el-button+.el-button{
      margin-left: 70px !important;
    }
  }
}
</style>
